import {profSpac} from 'constants/url';
import useUpdate from '../../../components/hooks/useUpdate';
import {EditingOptions} from '../../../components/grid-dx/types';

function useUpdateProfSpac() {
  const updateProfSpac = useUpdate(profSpac);
  return (editingOptions: EditingOptions) => updateProfSpac(editingOptions);
}

export default useUpdateProfSpac;
